<template>
  <div class="card p-10">
    <!--KÜNYE-->
    <ConfirmPopup class="confirmZ"></ConfirmPopup>
    <ImageModal
      :imgObj="imgObj"
      :auditId="auditId"
      @removeImg="removeImg"
    />

    <!-- ? Onay Butonu -->
    <div
      v-if="approvalButton"
      class="d-flex justify-content-end"
    >
      <button
        @click="sendApprove(auditId)"
        class="btn btn-sm btn-success mb-2"
      >
        <i class="bi bi-check-circle-fill fs-4"></i>
        <div
          v-if="loadingBtn"
          class="spinner-border spinner-border-sm mx-1"
        ></div>
        {{ translate("send_approve") }}
      </button>
    </div>

    <!-- ! KÜNYE -->
    <button
      class="accordion-button btn btn-primary collapsed ps-3 pt-5 pb-5 text-gray-700 rounded"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#info-body-1"
      aria-expanded="false"
      aria-controls="info-body-1"
    >
      <span class="fw-bold text-white fs-6 mx-5"
        ><i class="bi bi-info-circle fs-3 me-1"> </i> {{ translate("audit_report_main_title_informations") }}</span
      >
    </button>

    <div
      id="info-body-1"
      class="card accordion-collapse collapse show mt-10 min-h-100px"
    >
      <BlockUI
        :loading="summaryLoading"
        class="h-200px position-relative"
      />
      <div
        v-if="summary"
        class="card-body"
      >
        <div class="row mt-5">
          <span class="text-dark fw-bolder fs-6 col-sm mb-2">
            {{ translate("audit_report_summary_location") }}
          </span>

          <span class="text-dark fw-bolder text-muted fs-6 col-sm mb-2">
            {{ summary.LocationName }}
          </span>

          <span class="text-dark fw-bolder fs-6 col-sm mb-2">
            {{ translate("audit_report_summary_audit_date") }}
          </span>

          <span class="text-dark fw-bolder text-muted d-block fs-6 col-sm mb-2">
            {{ summary.BeginDate }}
          </span>
        </div>
        <div class="row mt-3">
          <div class="col-sm d-flex justify-content-start mb-2">
            <span class="text-dark fw-bolder fs-6">
              {{ translate("audit_report_summary_appropriate_answer_count") }}
            </span>
          </div>

          <div class="col-sm mb-2">
            <span class="text-dark fw-bolder text-muted fs-6">
              {{ summary.AppropriateAnswerCount }}
            </span>
          </div>

          <div class="col-sm mb-2 d-flex justify-content-start">
            <span class="text-dark fw-bolder fs-6 mt-1">
              {{ translate("audit_report_summary_inappropriate_answer_count") }}
            </span>
          </div>

          <div class="col-sm mb-2">
            <span class="text-dark fw-bolder text-muted d-block fs-6">
              {{ summary.InAppropriateAnswerCount }}
            </span>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-sm mb-2 d-flex justify-content-start">
            <span class="text-dark fw-bolder fs-6">
              {{ translate("audit_report_summary_TotalEarnedScore") }}
            </span>
          </div>

          <div class="col-sm mb-2">
            <span class="text-dark fw-bolder text-muted fs-6">
              {{ summary.TotalEarnedScore }}
            </span>
          </div>

          <div class="col-sm mb-2 d-flex justify-content-start">
            <span class="text-dark fw-bolder fs-6">
              {{ translate("audit_report_summary_total_available_score") }}
            </span>
          </div>

          <div class="col-sm mb-2">
            <span class="text-dark fw-bolder text-muted d-block fs-6">
              {{ summary.TotalAvailableScore }}
            </span>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-sm mb-2 d-flex justify-content-start">
            <span class="text-dark fw-bolder fs-6">
              {{ translate("audit_report_summary_auditer") }}
            </span>
          </div>

          <div class="col-sm mb-2">
            <span class="text-dark fw-bolder text-muted fs-6">{{ summary.AuditerName }}</span>
          </div>

          <div class="col-sm mb-2">
            <div class="d-flex justify-content-start">
              <span class="text-dark fw-bolder fs-6">
                {{ translate("audit_report_summary_achievement_score") }}
              </span>
            </div>
          </div>

          <div class="col-sm mb-2">
            <span class="text-dark fw-bolder text-muted d-block fs-6">
              %{{ summary.AchievementPoint.toString().substr(0, 4) }}
            </span>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-sm mb-2 d-flex justify-content-start">
            <span class="text-dark fw-bolder fs-6"> {{ translate("audit_report_summary_achievement_level") }}</span>
          </div>

          <div class="col-sm mb-2">
            <span class="text-dark fw-bolder text-muted fs-6">{{ summary.AchievementLevel }}</span>
          </div>
          <div class="col-lg-6"></div>
        </div>
        <div
          v-if="summary"
          class="row mt-5"
        >
          <div class="col-sm mb-2">
            <span
              ><a
                @click="reportPdf(auditId)"
                class="btn btn-sm btn-light-primary h-30px mb-2"
              >
                <div
                  v-if="loading"
                  class="spinner-border spinner-border-sm mx-1"
                ></div>
                <span class="indicator-label mb-3">
                  {{ translate("audit_report_pdf_reportt") }}
                </span>
              </a>
            </span>
          </div>
          <div class="col-lg-9"></div>
        </div>
      </div>
      <span
        v-else-if="!summaryLoading"
        class="text-center"
        >{{ translate("audit_report_summary_not_avaliable") }}</span
      >
    </div>

    <!-- ! BÖLÜMLER-->
    <div
      class="accordion-header mt-10"
      id="info-1"
    >
      <!--Bölümler accordion-->
      <button
        class="accordion-button btn btn-primary collapsed ps-3 pt-5 pb-5 text-gray-700 rounded"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#info-body-2"
        aria-expanded="false"
        aria-controls="info-body-1"
      >
        <span class="fw-bold text-white fs-5 mx-5">
          <i class="bi bi-border-width fs-3 me-1"></i>
          {{ translate("audit_report_main_title_sections") }}</span
        >
      </button>
      <!--Bölümler div-->

      <div
        id="info-body-2"
        class="card mt-10 accordion-collapse collapse show min-h-200px p-5"
      >
        <BlockUI
          :loading="sectionsLoading"
          class="position-relative h-200px"
        />
        <div
          v-if="sections.length > 0"
          class="card-body"
        >
          <!-- ? Genel Bölüm Bilgisi -->
          <table class="table table-row-dashed table-row-gray-300 align-middle mb-20">
            <thead>
              <tr
                style="vertical-align: middle"
                class="fw-bolder text-muted"
              >
                <th class="col-lg-2">
                  <span class="ms-5">{{ translate("audit_report_section_department") }}</span>
                </th>
                <th class="col-lg-2 text-center">
                  {{ translate("audit_report_section_category") }}
                </th>
                <th class="col-lg-2 text-center">
                  {{ translate("audit_report_section_available_score") }}
                </th>
                <th class="col-lg-2 text-center">
                  {{ translate("audit_report_section_received_score") }}
                </th>
                <th class="col-lg-2 text-center">
                  {{ translate("audit_report_section_success_rate") }}
                </th>
              </tr>
            </thead>
            <!--begin::Table body-->
            <tbody>
              <template
                v-for="(item, index) in sections"
                :key="index"
              >
                <tr style="vertical-align: middle">
                  <td class="col-lg-2">
                    <span
                      class="fw-bolder fs-6"
                      :class="` ${item.DepartmentName ? 'ms-0' : 'ms-5'}`"
                    >
                      {{ item.DepartmentName ? item.DepartmentName : "—" }}
                    </span>
                  </td>

                  <td class="col-lg-2 text-center">
                    <span class="fw-bolder fs-6">{{ item.CategoryName }}</span>
                  </td>

                  <td class="col-lg-2 text-center">
                    <span class="text-gray-800 fw-bolder fs-6">{{ item.AvailableScore }}</span>
                  </td>

                  <td class="col-lg-2 text-center">
                    <span class="text-gray-800 fw-bolder text-muted d-block fs-6">{{ item.EarnedScore }}</span>
                  </td>

                  <td class="col-lg-2 text-center">
                    <span class="text-gray-800 fw-bolder text-muted d-block fs-6">{{ item.AchievementScore }}</span>
                  </td>
                </tr>
              </template>
            </tbody>
            <!--end::Table body-->
          </table>
          <span
            class="fs-3 text-gray-800 ms-5 fw-bolder"
            v-if="departmentList.length > 0"
          >
            {{ translate("audit_report_department_chart") }}
          </span>
          <!-- ? Departman Skor Grafiği -->
          <div class="row">
            <div class="col-lg-5 mt-20">
              <div
                v-for="item in departmentList"
                :key="item.id"
                class="px-5"
              >
                <div class="d-flex align-items-center">
                  <div class="flex-grow-1 me-2">
                    <span class="text-gray-800 text-hover-primary fs-6 fw-bold">{{
                      item.DepartmentName ? item.DepartmentName : translate("Other")
                    }}</span>
                  </div>
                  <div class="badge p-3 fs-8 fw-bold badge-light">
                    {{ parseInt(item.EarnedScore / item.Count) }} {{ translate("question_component_input_point") }}
                  </div>
                </div>
                <div class="separator separator-dashed my-2"></div>
              </div>
            </div>

            <div
              class="col-lg-7 d-flex justify-content-start"
              style="padding-left: 12%"
            >
              <apexchart
                ref="refDepChart"
                v-if="DepartmentChart.series.length > 0"
                type="radar"
                height="350"
                :options="DepartmentChart.options"
                :series="DepartmentChart.series"
              ></apexchart>
            </div>
          </div>

          <!-- ?Kategori Skor Grafiği -->
          <div
            v-if="sections.length > 0"
            class="py-3 row"
          >
            <span class="ms-5 fs-3 text-gray-800 fw-bolder">{{ translate("audit_report_category_chart") }}</span>

            <div class="col-lg-5 mt-15">
              <div
                v-for="item in sections"
                :key="item.id"
                class="px-5"
              >
                <div class="d-flex align-items-center">
                  <div class="flex-grow-1 me-2">
                    <span class="text-gray-800 text-hover-primary fs-6 fw-bold">{{
                      item.CategoryName ? item.CategoryName : translate("Other")
                    }}</span>
                  </div>
                  <div class="badge p-3 fs-8 fw-bold badge-light">
                    {{ item.EarnedScore }} {{ translate("question_component_input_point") }}
                  </div>
                </div>
                <div class="separator separator-dashed my-2"></div>
              </div>
            </div>

            <div
              class="d-flex align-items-center justify-content-center col-lg-7"
              style="overflow: auto"
            >
              <apexchart
                ref="refCatChart"
                v-if="CategoryChart.series.length > 0"
                class="me-6"
                height="350"
                width="350"
                type="radar"
                :options="CategoryChart.options"
                :series="CategoryChart.series"
              ></apexchart>
              <div>
                <div
                  v-for="department in departmentList"
                  :key="department.DepartmentId"
                >
                  <div class="form-check form-check-custom form-check-solid mb-2">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :id="`check-${department.DepartmentId}`"
                      @change="onChangeCheckbox($event, department.DepartmentId)"
                      :checked="selectedIdList.some((id) => id === department.DepartmentId)"
                    />
                    <div class="d-flex flex-column position-relative w-100">
                      <label
                        class="form-check-label col-form-label fw-bold p-0"
                        :for="`check-${department.DepartmentId}`"
                        >{{ department.DepartmentName }}</label
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <span
          v-else-if="!sectionsLoading"
          class="text-center p-5 mt-20"
        >
          {{ translate("audit_report_section_not_avaliable") }}</span
        >
      </div>
    </div>

    <EditAnswer
      :id="id"
      @propsNull="modalClosed"
    />

    <!-- ! CEVAP DAĞILIMI  -->

    <div
      class="accordion-header mt-10"
      id="info-4"
    >
      <!--Bölümler accordion-->
      <button
        class="accordion-button btn btn-primary collapsed ps-3 pt-5 pb-5 text-gray-700 rounded"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#info-body-4"
        aria-expanded="false"
        aria-controls="info-body-4"
      >
        <span class="fw-bold text-white fs-5 mx-5">
          <i class="bi bi-border-width fs-3 me-1"></i>
          ANSWERS</span
        >
      </button>
      <!--Bölümler div-->

      <div
        id="info-body-4"
        class="card p-5 mt-10 accordion-collapse collapse show min-h-100px"
      >
        <BlockUI
          :loading="answerLoading"
          class="position-relative h-200px"
        />
        <div
          v-if="answerGroupList.length > 0"
          class="row mb-10"
        >
          <span class="fs-3 fw-bolder ms-10 mb-10">{{ translate("audit_report_answer_distribution") }}</span>

          <div
            v-for="answerGroup in answerGroupList"
            :key="answerGroup.id"
            class="col-lg-6 px-20"
          >
            <div class="d-flex align-items-center">
              <div class="flex-grow-1 me-2">
                <span class="text-gray-800 text-hover-primary fs-6 fw-bold">{{ answerGroup.name }}</span>
              </div>
              <div class="badge p-3 fs-8 fw-bold badge-light">
                {{ answerGroup.count }} {{ translate("analysis_count") }}
              </div>
            </div>
            <div class="separator separator-dashed my-2"></div>
          </div>
        </div>
        <div
          v-else-if="!answerLoading"
          class="d-flex justify-content-center align-items-center"
        >
          <span>{{ translate("audit_report_answer_not_avaliable") }}</span>
        </div>
      </div>
    </div>

    <!-- ! DENETİM DETAY-->
    <div
      class="accordion-header mt-10"
      id="info-1"
    >
      <button
        class="accordion-button btn btn-primary collapsed ps-3 pt-5 pb-5 text-gray-700 rounded"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#info-body-3"
        aria-expanded="false"
        aria-controls="info-body-1"
      >
        <span class="fw-bold text-white fs-5 mx-5">
          <i class="bi bi-globe fs-3 me-2"></i>{{ translate("audit_report_main_title_audit_detail") }}</span
        >
      </button>

      <!-- ? Body-->
      <div
        id="info-body-3"
        class="card mt-10 accordion-collapse collapse show min-w-200px"
      >
        <div class="card-body py-3">
          <BlockUI
            :loading="detailsLoading"
            class="h-300px position-relative"
          />
          <template
            v-for="(item, index) in Departments"
            :key="index"
          >
            <div
              class="accordion position-relative"
              id="department-info-department"
            >
              <div class="accordion-item mb-2 p-0">
                <h2
                  class="accordion-header"
                  id="header-department-info-department"
                >
                  <!-- ? Departman Button-->
                  <button
                    class="accordion-button collapsed pt-5 pb-5 fw-bold text-gray-600 bg-white !important"
                    type="button"
                    data-bs-toggle="collapse"
                    :data-bs-target="`#info-body--${item.DepartmentId}`"
                    aria-expanded="false"
                    aria-controls="info-body-1"
                  >
                    <td class="col-lg-3">
                      <div class="d-flex align-items-center">
                        <div class="d-flex justify-content-start">
                          <span
                            v-if="item.DepartmentName"
                            class="text-dark fw-bolder fs-6"
                          >
                            {{ item.DepartmentName }}
                          </span>
                          <span
                            v-else
                            class="text-dark fw-bolder fs-6"
                          >
                            {{ translate("audit_report_details_information_questions") }}
                          </span>
                        </div>
                      </div>
                    </td>
                  </button>
                </h2>
              </div>
            </div>
            <!-- ? Departman Body-->
            <div
              :id="`info-body--${item.DepartmentId}`"
              class="accordion-collapse show"
            >
              <template
                v-for="(itemC, index) in item.Categories"
                :key="index"
              >
                <div
                  class="accordion position-relative py-1"
                  id="department-info-category"
                >
                  <div class="accordion-item border border-solid">
                    <h2
                      class="accordion-header"
                      id="header-department-info-category"
                    >
                      <!-- ? Kategori Button-->
                      <button
                        class="accordion-button btn btn-light collapsed bg-secondary"
                        type="button"
                        data-bs-toggle="collapse"
                        :data-bs-target="`#info-body-${item.DepartmentId}-${itemC.CategoryId}`"
                        aria-expanded="false"
                        :aria-controls="`info-body-${item.DepartmentId}-${itemC.CategoryId}`"
                      >
                        <span class="bullet bullet-vertical h-30px bg-primary me-5 ms-0"></span>
                        <tr>
                          <td class="col-lg-3">
                            <div class="d-flex align-items-center">
                              <div class="d-flex justify-content-start">
                                <span
                                  v-if="itemC.CategoryName"
                                  class="text-dark fw-bolder fs-6"
                                >
                                  {{ itemC.CategoryName }}
                                </span>
                                <span
                                  v-else
                                  class="text-dark fw-bolder fs-6"
                                >
                                  {{ translate("audit_report_details_information_question") }}
                                </span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </button>
                    </h2>
                  </div>
                </div>
                <!-- ? Kategori Body-->
                <div
                  class="card accordion-collapse collapse show p-0 shadow-none"
                  :id="`info-body-${item.DepartmentId}-${itemC.CategoryId}`"
                >
                  <!--begin::Table container-->
                  <div class="table-responsive px-3 border-solid">
                    <!--begin::Table-->
                    <table class="table table-row-dashed table-row-gray-300 align-middle">
                      <thead
                        class="border-1 bg-light border-secondary"
                        style="font-size: small"
                      >
                        <tr
                          class="fw-bolder"
                          style="text-align: center"
                        >
                          <th
                            class="col-lg-1 py-3 ps-3 fs-6"
                            style="vertical-align: middle"
                          >
                            {{ translate("question_component_input_code") }}
                          </th>
                          <th
                            class="col-lg-3 text-center py-3 fs-6"
                            style="vertical-align: middle"
                          >
                            {{ translate("question_component_name") }}
                          </th>
                          <th
                            class="col-lg-1 text-center py-3 fs-6"
                            style="vertical-align: middle"
                          >
                            {{ translate("question_component_modal_label_answer_score") }}
                          </th>
                          <th
                            class="col-lg-1 text-center py-3 fs-6"
                            style="vertical-align: middle"
                          >
                            {{ translate("question_component_button_answer") }}
                          </th>
                          <th
                            class="col-lg-2 text-center py-3 fs-6"
                            style="vertical-align: middle"
                          >
                            {{ translate("audit_report_details_non_conformity") }}
                          </th>
                          <th
                            class="col-lg-3 text-center py-3 fs-6"
                            style="vertical-align: middle"
                          >
                            {{ translate("audit_report_details_evidence") }}
                          </th>
                          <th
                            class="col-lg-1 text-center py-3 pe-3 fs-6"
                            style="vertical-align: middle"
                          >
                            {{ translate("audit_report_details_process") }}
                          </th>
                        </tr>
                      </thead>
                      <!--begin::Table body-->
                      <tbody>
                        <template
                          v-for="(item, index) in itemC.Questions"
                          :key="index"
                        >
                          <tr
                            class="h-100px"
                            style="vertical-align: middle"
                          >
                            <td class="col-lg-1 fw-bolder fs-7 text-center">
                              {{ item.Code }}
                            </td>

                            <td class="col-lg-3 fw-bolder fs-7 text-center">
                              {{ item.QuestionText }}
                            </td>

                            <td class="col-lg-1 fw-bolder fs-7 text-center">
                              <span v-if="item.IsInfo == false">
                                {{ item.Score }}
                              </span>
                            </td>

                            <td class="col-lg-2 fw-bolder fs-7 text-center">
                              {{ item.AnswerText }}
                            </td>
                            <td class="col-lg-1 fw-bolder fs-7 text-center">
                              {{ item.AnswerValue }}
                            </td>
                            <td class="col-lg-3">
                              <div class="d-flex flex-wrap">
                                <a
                                  type="button"
                                  id="imageDiv"
                                  v-for="img in item.Pictures"
                                  :key="img.Id"
                                  class="m-1"
                                  @click="openImgModal(img)"
                                  data-bs-toggle="modal"
                                  data-bs-target="#add-img-modal"
                                >
                                  <img
                                    v-if="!controlVideo(img.Url)"
                                    :src="img.Url"
                                    alt="image"
                                    class="h-50px w-50px"
                                    style="background-color: white; object-fit: cover"
                                  />
                                  <div
                                    v-else
                                    class="position-relative"
                                  >
                                    <img
                                      src="https://iphone7papers.com/wp-content/uploads/papers.co-sb15-wallpaper-vanishing-line-blur-33-iphone6-wallpaper-250x444.jpg"
                                      class="h-50px w-50px d-block"
                                    />
                                    <i
                                      style="bottom: 25%; left: 25%"
                                      class="bi bi-play-fill position-absolute text-white fs-1"
                                    ></i>
                                  </div>
                                </a>
                              </div>
                            </td>

                            <td
                              style="vertical-align: middle"
                              class="text-center"
                            >
                              <a
                                class="btn btn-icon btn-bg-primary btn-color-white btn-sm me-1"
                                data-bs-toggle="modal"
                                data-bs-target="#update-answer-modal"
                                @click="modalId(item.Id)"
                              >
                                <span class="svg-icon svg-icon-3">
                                  <inline-svg src="media/icons/duotune/art/art005.svg" />
                                </span>
                              </a>
                            </td>
                          </tr>
                        </template>
                      </tbody>
                      <!--end::Table body-->
                    </table>
                    <!--end::Table-->
                  </div>

                  <!--end::Table container-->
                </div>
              </template>
            </div>
          </template>
        </div>
        <div
          v-if="!detailsLoading && Departments.length == 0"
          class="d-flex justify-content-center"
        >
          <span>{{ translate("audit_report_detail_not_avaliable") }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, provide, onMounted, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import EditAnswer from "@/components/Audit/AuditDetailModal/EditAnswer.vue";
import { useConfirm } from "primevue/useconfirm";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import ImageModal from "@/components/Audit/Modals/ImageModal.vue";

//Çoklu dil tanımalamas
const { t, te, locale } = useI18n();
const translate = (text) => {
  if (te(text)) {
    return t(text);
  } else {
    return text;
  }
};

const store = useStore();
const route = useRoute();
const msgConfirm = useConfirm();
const auditId = parseInt(route.params.id);
provide("auditId", auditId);

const summary = ref(null);
const Departments = ref([]);
const loading = ref(false);
const sections = ref([]);
const loadingBtn = ref(false);
const approvalButton = ref(false);
const id = ref(0);

const imgObj = ref({
  Id: 0,
  Url: null,
});

//props gönderme
const modalId = (Id) => {
  id.value = Id;
};

const sectionsLoading = ref(true);
const summaryLoading = ref(true);
const detailsLoading = ref(true);
const answerLoading = ref(true);

//Denetim Künye Bilgileri
const getAuditSummary = () => {
  store.dispatch("AuditReportModule/GET_REPORT_SUMMARY", auditId).then((response) => {
    summary.value = response;
    summaryLoading.value = false;
  });
};

const departmentList = ref([]);
const categoryList = ref([]);
const refDepChart = ref(null);
const refCatChart = ref(null);

//Denetim Bölüm Bilgileri
const getSections = (auditId) => {
  store.dispatch("AuditReportModule/GET_REPORT_DEPARTMENT", auditId).then((response) => {
    sections.value = response;

    // response kategoriye göre ayrıldığı için departmanlar gruplandı

    response.forEach((departmentItem) => {
      let listIndex = departmentList.value.findIndex(
        (department) => department.DepartmentId === departmentItem.DepartmentId
      );
      if (listIndex > -1) {
        departmentList.value[listIndex].EarnedScore += parseInt(departmentItem.EarnedScore);
        departmentList.value[listIndex].Count += 1;
      } else {
        let obj = {
          DepartmentId: departmentItem.DepartmentId,
          DepartmentName: departmentItem.DepartmentName ? departmentItem.DepartmentName : translate("Other"),
          AvailableScore: departmentItem.AvailableScore,
          EarnedScore: parseFloat(departmentItem.EarnedScore),
          Count: 1,
        };

        departmentList.value.push(obj);
      }
    });

    // Gruplanan departmanlar charta eklendi
    DepartmentChart.value.options.xaxis.categories = departmentList.value.map((item) =>
      item.DepartmentName ? item.DepartmentName : translate("Other")
    );
    DepartmentChart.value.series = [
      {
        name: "Score",
        data: departmentList.value.map((item) => parseInt(item.EarnedScore / item.Count)),
      },
    ];

    // Gruplanan kategoriler charta eklendi
    categoryList.value = response;
    CategoryChart.value.options.xaxis.categories = categoryList.value.slice(0, 10).map((item) => item.CategoryName);

    // radarChart series array şeklinde kabul edildiği için
    let categoryChartSeries = [
      {
        name: "Score",
        data: categoryList.value.slice(0, 10).map((item) => item.EarnedScore),
      },
    ];
    CategoryChart.value.series = categoryChartSeries;

    selectedIdList.value.push(departmentList.value[0].DepartmentId);
    sectionsLoading.value = false;
  });
};

const answerGroupList = ref([]);
//Denetim Detay Bilgileri
const getAuditDetails = (Id) => {
  answerGroupList.value = [];
  store.dispatch("AuditReportModule/GET_REPORT_DETAILS", Id).then((response) => {
    if (response) {
      Departments.value = response;
      response.forEach((department) => {
        department.Categories.forEach((category) => {
          category.Questions.forEach((question) => {
            if (question.AnswerTemplateId != 0) {
              const answerGroupIndex = answerGroupList.value.findIndex(
                (answerTemp) => answerTemp.id === question.AnswerTemplateId
              );

              if (answerGroupIndex > -1) {
                answerGroupList.value[answerGroupIndex].count += 1;
              } else {
                let obj = {
                  name: question.AnswerText,
                  count: 1,
                  id: question.AnswerTemplateId,
                };
                answerGroupList.value.push(obj);
              }
            }
          });
        });
      });
      answerLoading.value = false;
      detailsLoading.value = false;
    } else {
      answerLoading.value = false;
      detailsLoading.value = false;
    }
  });
};
loadingBtn;
//Onay gönderme
const sendApprove = (payload) => {
  msgConfirm.require({
    target: event.currentTarget,
    message: translate("audit_approve_message"),
    icon: "pi pi-exclamation-triangle",
    acceptLabel: translate("customer_location_confirm_acceptLabel"),
    rejectLabel: translate("customer_location_confirm_rejectLabel"),
    acceptClass: "btn btn-sm btn-primary",
    rejectClass: "btn btn-sm btn-light",
    accept: () => {
      loadingBtn.value = true;
      store.dispatch("AuditReportModule/APPROVE_AUDIT", payload).then((response) => {
        loadingBtn.value = false;

        setTimeout(() => {
          getAudit();
        }, 500);
      });
    },
    reject: () => {
      return;
    },
  });
};

// Alt komponentte watch kontrolü yapmak için id sıfırlama
const modalClosed = (isResponse) => {
  id.value = 0;
  if (isResponse) {
    getAuditDetails(auditId);
  }
};

//Pdf indirme
const reportPdf = (payload) => {
  loading.value = true;
  store.dispatch("AuditReportModule/REPORT_PDF", payload).then((response) => {
    loading.value = false;
    window.open(URL.createObjectURL(response));
  });
};

//Image Modal Click
const openImgModal = (img) => {
  (imgObj.value.Id = img.Id), (imgObj.value.Url = img.Url);
};

//Video olup olmadığı kontrolü
const controlVideo = (path, a) => {
  if (path != null) {
    const middlePath = path.substring(path.length - 3);
    if (middlePath == "mp4") {
      return true;
    } else {
      return false;
    }
  }
};

//Denetimin durumu kontrolü
const getAudit = () => {
  store.dispatch("AuditPlanningModule/GET_AUDIT_PLANNING", auditId).then((response) => {
    if (response.StatusValue == 30) {
      approvalButton.value = true;
    } else {
      approvalButton.value = false;
    }
  });
};

const removeImg = () => {
  getAuditDetails(auditId);
};

const DepartmentChart = ref({
  options: {
    chart: {
      height: 150,
      width: 150,

      type: "radar",
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: true,
    },
    plotOptions: {
      radar: {
        size: 120,
      },
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val;
        },
      },
    },
    markers: {
      size: 3,
      hover: {
        size: 10,
      },
    },
    xaxis: {
      categories: [],
      labels: {
        trim: true,
        formatter: (value) => {
          var len = value.length;
          return len > 25 ? value.substring(0, 22) + "..." : value;
        },
      },
    },
    yaxis: {
      labels: {
        formatter: function (val, i) {
          if (i % 2 === 0) {
            return val;
          } else {
            return "";
          }
        },
        labels: {
          trim: true,
          style: {},
          width: "10px",
        },
      },
    },
    stroke: {
      width: 1,
    },
    legend: {
      position: "right",
      width: 1,
    },
    colors: ["red"],
    noData: {
      text: translate("analysis_no_data_criterie"),
      align: "center",
      verticalAlign: "middle",
      offsetX: 0,
      offsetY: 0,
      style: {
        color: undefined,
        fontSize: "13px",
        fontFamily: undefined,
        height: "400px",
      },
    },
  },
  series: [],
});

//Kategorideki son iki denetim karşılaştırması radarChart
const CategoryChart = ref({
  options: {
    chart: {
      height: 150,
      width: 150,
      type: "radar",
      toolbar: {
        show: false,
      },
    },
    markers: {
      size: 3,
      hover: {
        size: 10,
      },
    },
    dataLabels: {
      enabled: true,
    },
    plotOptions: {
      radar: {
        size: 120,
      },
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val;
        },
      },
    },
    xaxis: {
      categories: [],
      labels: {
        trim: true,
        formatter: (value) => {
          var len = value.length;
          return len > 15 ? value.substring(0, 10) + "..." : value;
        },
      },
    },
    yaxis: {
      labels: {
        formatter: function (val, i) {
          if (i % 2 === 0) {
            return val;
          } else {
            return "";
          }
        },
        labels: {
          trim: true,
          style: {},
          width: "10px",
        },
      },
    },
    stroke: {
      width: 1,
    },
    legend: {
      position: "right",
      width: 1,
    },
    noData: {
      text: translate("analysis_no_data_criterie"),
      align: "center",
      verticalAlign: "middle",
      offsetX: 0,
      offsetY: 0,
      style: {
        color: undefined,
        fontSize: "13px",
        fontFamily: undefined,
        height: "400px",
      },
    },
  },
  series: [],
});
const selectedIdList = ref([]);
const onChangeCheckbox = (event, departmentId) => {
  if (event.target.checked) {
    selectedIdList.value.push(departmentId);
  } else {
    selectedIdList.value = selectedIdList.value.filter((id) => id != departmentId);
  }
  let newCategories = sections.value.filter((element) => selectedIdList.value.includes(element.DepartmentId));

  CategoryChart.value.options.xaxis.categories = newCategories.map((category) => category.CategoryName);
  CategoryChart.value.series = [
    {
      name: "Category",
      data: newCategories.map((category) => category.EarnedScore),
    },
  ];
};

getAudit();
getAuditSummary(auditId);

//bölümleri çağırma
getSections(auditId);

// detayı çağırma
getAuditDetails(auditId);

watch(locale, () => {
  setCurrentPageBreadcrumbs(t("Menu_Audit_Details"), []);
});

onMounted(() => {
  setCurrentPageBreadcrumbs(t("Menu_Audit_Details"), []);
});
</script>
<style>
.accordion-button.collapsed::after {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
}

#imageDiv:hover {
  cursor: pointer;
}
.confirmZ {
  z-index: 1050 !important ;
}
</style>
